import { Bold, Italic, Redo2, Underline, Undo2 } from "lucide-react";

import { IgIconButton } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { FontSizeSelect } from "@src/components/RichTextEditor/MenuBar/FontSizeSelect";
import { MenuBarColorPicker } from "@src/components/RichTextEditor/MenuBar/MenuBarColorPicker";
import { RichEditorState } from "@src/components/RichTextEditor/types";
import { Editor } from "@tiptap/react";

interface MenuBarProps {
  editor: Editor;
  state: RichEditorState;
  disabled: boolean;
}

export const MenuBar = ({ editor, state, disabled }: MenuBarProps) => {
  const theme = useTheme();
  if (!editor) {
    return null;
  }

  return (
    <Stack
      direction={"row"}
      sx={{
        borderBottom: `1px solid ${theme.igBorders.core.default}`,
        padding: 1,
        alignItems: "center",
      }}
    >
      <IgIconButton
        size={"small"}
        onClick={() => editor.chain().focus().undo().run()}
        disabled={!state.undoEnabled || disabled}
      >
        <Undo2 size={16} />
      </IgIconButton>
      <IgIconButton
        size={"small"}
        onClick={() => editor.chain().focus().redo().run()}
        disabled={!state.redoEnabled || disabled}
      >
        <Redo2 size={16} />
      </IgIconButton>

      <FontSizeSelect
        title={"text size"}
        disabled={disabled}
        value={state.fontSize}
        onChange={(fontSize) =>
          editor.chain().focus().setFontSize(fontSize).run()
        }
      />
      <MenuBarColorPicker
        title={"text color"}
        value={state.color}
        disabled={disabled}
        onChange={(color) => editor.chain().focus().setColor(color).run()}
      />
      <IgIconButton
        disabled={disabled}
        size={"small"}
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={state.bold ? "active" : ""}
      >
        <Bold size={16} />
      </IgIconButton>
      <IgIconButton
        disabled={disabled}
        size={"small"}
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={state.italic ? "active" : ""}
      >
        <Italic size={16} />
      </IgIconButton>
      <IgIconButton
        size={"small"}
        disabled={disabled}
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        className={state.underline ? "active" : ""}
      >
        <Underline size={16} />
      </IgIconButton>
    </Stack>
  );
};
